/* src/app/llp-page/llp-page.component.css */
.l-section1 {
  display: flex;
  flex-direction: column;
  background-image: url(/assets/images/l-bg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.l-header {
  display: flex;
}
.l-header img {
  width: 250px;
  height: 80px;
  margin: 25px;
  cursor: pointer;
}
.l-hero {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
}
.l-hero h1 {
  margin-top: 50px;
  font-size: 48px;
  font-weight: 600;
}
.l-hero h4 {
  font-size: 24px;
}
.l-hero p {
  text-align: center;
  font-size: 18px;
}
.l-btn-hero {
  margin-top: 25px;
  display: flex;
  align-items: center;
  gap: 25px;
}
.l-btn-hero button {
  padding: 15px 30px;
  font-size: 18px;
  border-radius: 20px;
  border: none;
  color: white;
}
.org {
  background: #ED6823;
}
.blc {
  background: #060606;
}
.l-mid-section {
  margin-top: 25px;
  width: 80%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(/assets/images/mid-bg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 25px;
}
.l-mid-section h4 {
  font-size: 24px;
  color: white;
  text-align: center;
  line-height: 2;
}
.about-section {
  text-align: center;
  padding: 56px 8px 48px 8px;
  background: #fff;
}
.about-title {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 14px;
  margin-top: 0;
  font-family:
    "Segoe UI",
    Arial,
    sans-serif;
}
.about-subtext {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 12px;
}
.about-desc {
  font-size: 22px;
  color: #222;
  margin-bottom: 38px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}
.about-highlight {
  color: #ff6f1f;
  font-weight: 600;
}
.stats-cards {
  display: flex;
  gap: 36px;
  justify-content: center;
  margin-top: 12px;
  flex-wrap: wrap;
}
.stat-card {
  background: #f4f4f4;
  border-radius: 18px;
  box-shadow: 0 3px 10px 0 rgba(60, 60, 60, .07);
  padding: 48px 38px 38px 38px;
  min-width: 260px;
  max-width: 320px;
  flex: 1 1 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 18px;
}
.stat-number {
  font-size: 6rem;
  font-weight: 600;
  margin-bottom: 7px;
}
.stat-label {
  font-size: 18px;
  font-weight: 400;
  color: #181818;
}
.page-container {
  min-height: 100vh;
  background: #f4f6f8;
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.main-title {
  font-size: 48px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 32px;
  font-family:
    "Segoe UI",
    "Arial",
    sans-serif;
}
.browser-window {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  width: 80%;
  overflow: hidden;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.window-bar {
  height: 32px;
  background: #f4f6f8;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.window-dot {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
}
.red {
  background: #ff605c;
}
.yellow {
  background: #ffbd44;
}
.green {
  background: #00ca4e;
}
.browser-tab {
  margin: -16px auto 0 auto;
  padding: 6px 28px;
  background: #fff;
  border-radius: 8px;
  font-weight: 500;
  color: #212121;
  font-size: 1.05rem;
  letter-spacing: 0.01em;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.02);
  z-index: 1;
}
.content-section {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 28px 38px 18px 38px;
  text-align: center;
}
.highlight-title {
  color: #ff6f1f;
  font-size: 3rem;
  font-weight: 600;
  margin-bottom: 18px;
  margin-top: 12px;
}
.subtext {
  width: 80%;
  color: #353535;
  font-size: 18px;
  margin-bottom: 25px;
  line-height: 1.8;
}
.orange-link {
  color: #ff6f1f;
  text-decoration: underline;
  font-weight: 500;
}
.bold-text {
  font-weight: 600;
  font-size: 24px;
  margin: 18px 0 22px 0;
}
.cta-btn {
  background: #ff6f1f;
  color: #fff;
  border: none;
  padding: 16px 36px;
  font-size: 18px;
  border-radius: 999px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 8px;
  margin-top: 5px;
  box-shadow: 0 2px 8px rgba(255, 111, 31, 0.08);
  transition: background 0.15s;
}
.cta-btn:hover {
  background: #e05b05;
}
.classroom-img {
  width: 100%;
  display: block;
  margin-top: 0;
  border-radius: 0 0 18px 18px;
  max-height: 350px;
  object-fit: cover;
}
.programs-section {
  text-align: center;
  background: #fff;
  padding: 40px 8px 32px 8px;
}
.programs-title {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 24px;
}
.programs-card {
  display: flex;
  align-items: stretch;
  justify-content: center;
  max-width: 1250px;
  background: #f4f4f4;
  margin: 0 auto;
  border-radius: 36px;
  overflow: hidden;
  box-shadow: 0 3px 12px 0 rgba(80, 80, 80, .06);
  padding: 0;
}
.programs-list {
  flex: 2 1 420px;
  text-align: left;
  font-size: 1.45rem;
  font-weight: 500;
  padding: 48px 32px 44px 48px;
  margin: 0;
  list-style: disc outside;
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.programs-list li {
  font-size: 20px;
  margin-bottom: 0;
  font-weight: 500;
}
.programs-img-wrap {
  flex: 1 1 320px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.programs-img {
  width: 100%;
  max-width: 360px;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 0 36px 36px 0;
}
.ai-insight-section {
  background: #fff;
  padding: 46px 0 40px 0;
  margin: 0 auto;
  width: 80%;
}
.apple-gradient {
  font-size: 48px;
  font-weight: 600;
  text-align: center;
  background:
    linear-gradient(
      270deg,
      #ff0057,
      #ff7c00,
      #ffee00,
      #00ff85,
      #00cfff,
      #8f00ff,
      #ff0057);
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: shine 5s linear infinite;
}
@keyframes shine {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 200% center;
  }
}
.ai-insight-lead {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 6px;
  margin-top: 12px;
}
.ai-insight-desc {
  text-align: center;
  font-size: 22px;
  color: #171717;
  margin-bottom: 26px;
  font-weight: 400;
  max-width: 740px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}
.ai-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.ai-card {
  display: flex;
  background: #fafcfd;
  border: 1.5px solid #eee;
  border-radius: 10px;
  align-items: center;
  margin-bottom: 0;
  overflow: hidden;
}
.ai-card-left {
  flex: 1.5;
  padding: 24px 26px;
  min-width: 0;
}
.ai-card-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 7px;
  color: #1f2533;
}
.ai-card-text {
  color: #333;
  font-size: 18px;
  line-height: 1.55;
}
.ai-card-image img {
  width: 300px;
  height: 100%;
  display: block;
  object-fit: cover;
}
@media (max-width: 700px) {
  .ai-insight-section {
    padding: 15px 0 20px 0;
  }
  .ai-gradient-title {
    font-size: 1.26rem;
  }
  .ai-cards {
    gap: 15px;
  }
  .ai-card {
    flex-direction: column;
    align-items: stretch;
  }
  .ai-card-left {
    padding: 18px 12px;
  }
  .ai-card-image img {
    width: 92px;
    height: 66px;
  }
}
.no-stress-section {
  margin-top: 25px;
  position: relative;
  width: 100%;
  min-height: 550px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #101010;
  overflow: hidden;
}
.no-stress-bg {
  position: absolute;
  inset: 0;
  background-image: url(/assets/images/no-st-setup.jpg);
  background-size: cover;
  background-position: center;
  filter: brightness(0.35);
  z-index: 1;
  background-attachment: fixed;
}
.no-stress-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  min-height: 520px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  gap: 25px;
  padding: 38px 15px 25px 15px;
  text-align: center;
}
.no-stress-title {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 26px;
  margin-top: 0;
  color: white;
}
.no-stress-badge {
  margin: 0 auto 18px auto;
  display: flex;
  align-items: center;
  font-size: 36px;
  font-family:
    "Segoe UI",
    Arial,
    sans-serif;
  flex-wrap: wrap;
}
.badge-main {
  background: #ff6f1f;
  color: #fff;
  padding: 1px 8px 2px 8px;
  border-radius: 4px 0 0 4px;
  font-weight: 500;
  margin-right: 0;
}
.badge-bold {
  background: #fff;
  color: #222;
  padding: 1px 12px 2px 7px;
  border-radius: 0 4px 4px 0;
  font-weight: 500;
}
.no-stress-try {
  font-size: 6rem;
  font-weight: 700;
  margin: 33px 0 28px 0;
  line-height: 1.06;
}
.no-stress-btn {
  background: #ff6f1f;
  color: #fff;
  border: none;
  padding: 18px 44px;
  font-size: 18px;
  border-radius: 999px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(255, 111, 31, 0.06);
  margin-bottom: 38px;
  margin-top: -3px;
  transition: background 0.15s;
}
.no-stress-btn:hover {
  background: #e05b05;
}
.no-stress-footer {
  font-size: 2rem;
  font-weight: 500;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin: 0 auto;
  max-width: 600px;
}
.love-section {
  background: #fafdff;
  padding: 38px 0 54px 0;
  text-align: center;
}
.love-title {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 0.2em;
}
.love-orange {
  color: #ff6f1f;
}
.love-heart {
  font-size: 30px;
  color: #ee3030;
  font-weight: 600;
  margin: 0.25em auto 0.3em auto;
  letter-spacing: 0.04em;
}
.love-btn-wrap {
  margin: 0.25em 0 1.9em 0;
}
.love-btn {
  background: #ff6f1f;
  color: #fff;
  padding: 18px 54px;
  font-size: 30px;
  font-weight: 600;
  border: none;
  border-radius: 2em;
  box-shadow: 0 2px 8px rgba(255, 111, 31, 0.10);
  cursor: pointer;
  transition: background 0.17s;
  outline: none;
}
.love-btn:hover {
  background: #e05b05;
}
.love-features-row {
  display: flex;
  gap: 30px;
  justify-content: center;
  align-items: stretch;
  margin-top: 22px;
  flex-wrap: wrap;
}
.love-feature-card {
  background: #fafdff;
  border-radius: 14px;
  padding: 28px 28px 23px 28px;
  min-width: 280px;
  max-width: 340px;
  flex: 1 1 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: box-shadow 0.16s;
}
.love-feature-card:hover {
  box-shadow: 0 5px 19px 0 rgba(255, 111, 31, 0.10);
}
.feature-img {
  width: 205px;
  height: 205px;
  margin-bottom: 18px;
  object-fit: contain;
}
.feature-heading {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 0.04em;
}
.feature-desc {
  font-size: 16px;
  color: #1a1a1a;
  text-align: center;
  line-height: 1.6;
}
.mission-section {
  max-width: 100vw;
  padding: 0 0 54px 0;
}
.mission-section h2 {
  text-align: center;
  font-size: 48px;
  font-weight: 600;
  margin: 44px 0 20px 0;
}
.mission-card {
  background: #fafafa;
  border-radius: 28px;
  max-width: 80vw;
  margin: 0 auto;
  padding: 38px 36px 54px 36px;
  box-sizing: border-box;
  box-shadow: 0 4px 20px rgba(130, 130, 130, 0.06);
}
.window-bar {
  margin-bottom: 28px;
  display: flex;
  align-items: center;
  height: 20px;
  padding-left: 8px;
}
.dot {
  height: 17px;
  width: 17px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 9px;
  background: #fff;
}
.dot-red {
  background: #f44336;
}
.dot-yellow {
  background: #ffe135;
}
.dot-green {
  background: #3aff7a;
}
.mission-row {
  display: flex;
  justify-content: center;
  gap: 48px;
}
.mission-col {
  flex: 1 1 0px;
  max-width: 350px;
  min-width: 200px;
  text-align: left;
}
.mission-icon {
  color: #f26c1b;
  font-size: 3.9rem;
  margin-bottom: 18px;
  text-align: left;
}
.mission-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 14px;
  line-height: 1.25;
}
.mission-text {
  font-size: 1.3rem;
  color: #181818;
  line-height: 1.4;
}
.global-footprint-section {
  background: #fff;
  padding: 36px 0 0 0;
  text-align: center;
  margin-bottom: 25px;
}
.global-title {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 32px;
}
.global-row {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 16px;
  max-width: 1150px;
  margin: 0 auto 0 auto;
}
.global-card {
  position: relative;
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px 0 rgba(50, 50, 60, 0.10);
  min-height: 260px;
}
.global-card-large {
  flex: 2 1 540px;
  min-width: 350px;
  min-height: 270px;
  margin-bottom: 0;
}
.global-card-small {
  flex: 1 1 270px;
  min-width: 230px;
  min-height: 270px;
  margin-bottom: 0;
}
.global-card::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(20, 24, 39, 0.45);
  z-index: 1;
}
.global-card-text {
  position: relative;
  z-index: 2;
  color: #fff;
  font-size: 3rem;
  font-weight: 600;
  text-align: center;
  padding: 0 12px;
}
.global-divider {
  margin: 24px 0 20px 0;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.01em;
}
.site-footer {
  background: #f4f4f4;
  padding: 25px 0 10px 0;
  text-align: center;
  font-family:
    "Segoe UI",
    Arial,
    sans-serif;
  border-top: 5px solid #191919;
}
.footer-top {
  margin-bottom: 10px;
}
.footer-logo {
  width: 160px;
  max-width: 95vw;
  margin-bottom: 4px;
}
.footer-links-row {
  display: flex;
  gap: 24px;
  justify-content: center;
  align-items: center;
  font-size: 1.7rem;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.footer-label {
  font-weight: 700;
  font-size: 1.4rem;
  margin-right: 8px;
}
.footer-link {
  font-size: 1.35rem;
  font-weight: 400;
}
.footer-contact-row {
  display: flex;
  gap: 60px;
  justify-content: center;
  align-items: center;
  font-size: 1.41rem;
  margin-bottom: 18px;
  flex-wrap: wrap;
}
.footer-contact {
  font-weight: 600;
  font-size: 1.21rem;
}
.footer-contact a {
  color: #1a1a1a;
  text-decoration: none;
  font-weight: 700;
}
.footer-contact a:hover {
  text-decoration: underline;
}
.footer-bottom {
  font-size: 1.17rem;
  text-align: center;
  margin-top: 12px;
  font-weight: 500;
  letter-spacing: 1px;
}
.demo-modal-overlay {
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(30, 29, 29, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.flip-modal {
  perspective: 1300px;
  width: 420px;
  max-width: 92vw;
  min-height: 520px;
  position: relative;
  background: transparent;
  border-radius: 22px;
  padding: 0;
  box-shadow: none;
}
.flip-face {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  backface-visibility: hidden;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 6px 45px 0 rgba(0, 0, 0, 0.14);
  padding: 36px 32px 28px 32px;
  box-sizing: border-box;
}
.flip-front {
  z-index: 2;
  transform: rotateY(0deg);
}
.flip-back {
  transform: rotateY(180deg);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 420px;
}
.flip-modal.flipped .flip-front {
  transform: rotateY(-180deg);
}
.flip-modal.flipped .flip-back {
  transform: rotateY(0deg);
}
.flip-modal,
.flip-face {
  transition: transform 0.7s cubic-bezier(.45, 1.38, .35, 1.02);
}
.demo-modal {
}
.demo-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}
.demo-modal-header h2 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  color: #222;
}
.close-btn {
  font-size: 2rem;
  background: none;
  border: none;
  color: #ed6823;
  cursor: pointer;
  margin-left: 12px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  text-align: center;
  transition: background 0.13s;
}
.close-btn:hover {
  background: #ffeae0;
}
.thanks-close-btn {
  position: absolute;
  right: 22px;
  top: 16px;
  z-index: 4;
  font-size: 2.2rem;
  color: #cf5b16;
  background: none;
  border: none;
  cursor: pointer;
}
.demo-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.form-row {
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.form-row-2 {
  display: flex;
  gap: 18px;
}
.form-row-2 > div {
  flex: 1 1 0;
}
.demo-form label {
  font-weight: 500;
  color: #444;
  margin-bottom: 1px;
}
.demo-form input,
.demo-form textarea {
  padding: 9px 13px;
  border-radius: 10px;
  border: 1.5px solid #eaeaea;
  font-size: 1.1rem;
  background: #fafafa;
  margin-bottom: 0;
  transition: border-color 0.15s;
}
.demo-form input:focus,
.demo-form textarea:focus {
  outline: none;
  border-color: #ed6823;
  background: #fff;
}
.demo-form textarea {
  min-height: 50px;
  max-height: 120px;
  resize: vertical;
}
.demo-submit-btn {
  width: 100%;
  margin-top: 10px;
  padding: 13px 0;
  border-radius: 22px;
  font-size: 1.15rem;
  font-weight: 600;
  background: #ed6823;
  color: #fff;
  border: none;
  box-shadow: 0 2px 7px rgba(237, 104, 35, 0.08);
  cursor: pointer;
  transition: background 0.15s;
  letter-spacing: 0.05em;
}
.demo-submit-btn[disabled] {
  opacity: 0.65;
  cursor: not-allowed;
}
.demo-submit-btn:hover:not([disabled]) {
  background: #c6591b;
}
.thank-you-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  min-height: 270px;
}
.thank-you-icon {
  margin-bottom: 18px;
}
.thank-you-title {
  font-size: 2.3rem;
  font-weight: 700;
  color: #1ec871;
  margin-bottom: 8px;
}
.thank-you-msg {
  font-size: 1.25rem;
  color: #222;
}
@media (max-width: 600px) {
  .flip-modal,
  .flip-face {
    padding: 14px 2vw 16px 2vw;
  }
  .thank-you-title {
    font-size: 1.5rem;
  }
  .thank-you-msg {
    font-size: 1.02rem;
  }
  .flip-modal {
    min-height: 410px;
  }
  .flip-back {
    min-height: 310px;
  }
  .thank-you-content {
    min-height: 180px;
  }
  .close-btn,
  .thanks-close-btn {
    font-size: 2rem;
    width: 32px;
    height: 32px;
  }
  .thank-you-icon svg {
    width: 48px;
    height: 48px;
  }
}
@media (max-width: 1200px) {
  .l-hero h1 {
    font-size: 42px;
  }
  .model-bottom-text {
    font-size: 1.8rem;
  }
}
@media (max-width: 992px) {
  .programs-list li {
    font-size: 20px;
  }
  .model-benefit-card {
    max-width: 280px;
  }
}
@media (max-width: 768px) {
  .l-header img {
    width: 180px;
    height: 60px;
    margin: 15px;
  }
  .l-hero h1 {
    font-size: 32px;
    padding: 0 15px;
    text-align: center;
  }
  .l-hero h4 {
    font-size: 20px;
    text-align: center;
    padding: 0 15px;
  }
  .l-hero p {
    font-size: 16px;
    padding: 0 15px;
  }
  .l-btn-hero {
    flex-direction: column;
  }
  .l-mid-section {
    height: auto;
    padding: 40px 15px;
  }
  .l-about {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
  }
  .about-subtext {
    font-size: 20px;
    padding: 0 15px;
  }
  .about-desc {
    font-size: 18px;
    padding: 0 15px;
  }
  .main-title {
    font-size: 36px;
  }
  .highlight-title {
    font-size: 28px;
  }
  .subtext {
    width: 100%;
    padding: 0 15px;
  }
  .programs-title {
    font-size: 36px;
  }
  .programs-card {
    flex-direction: column;
  }
  .programs-list {
    padding: 30px 20px;
  }
  .programs-img {
    border-radius: 0;
  }
  .model-title {
    font-size: 36px;
  }
  .model-benefit-card {
    max-width: 100%;
    width: 100%;
  }
  .model-bottom-text {
    font-size: 1.6rem;
    padding: 0 15px;
  }
  .no-stress-title {
    font-size: 36px;
  }
  .no-stress-badge {
    font-size: 24px;
    flex-direction: column;
  }
  .badge-main,
  .badge-bold {
    border-radius: 4px;
    margin: 5px;
  }
  .no-stress-try {
    font-size: 4rem;
  }
  .love-title {
    font-size: 36px;
  }
  .love-btn {
    font-size: 24px;
    padding: 15px 40px;
  }
  .mission-title {
    font-size: 36px;
  }
  .mission-headline {
    font-size: 24px;
    padding: 8px 20px;
  }
  .mission-desc {
    font-size: 16px;
  }
  .global-title {
    font-size: 36px;
  }
  .global-row {
    flex-direction: column;
    padding: 0 15px;
  }
  .global-card {
    width: 100%;
    min-height: 200px;
  }
  .global-card-text {
    font-size: 24px;
  }
  .footer-links-row,
  .footer-contact-row {
    flex-direction: column;
    gap: 15px;
  }
}
@media (max-width: 480px) {
  .l-hero h1 {
    font-size: 28px;
  }
  .l-hero h4 {
    font-size: 18px;
  }
  .model-how-helps-label {
    font-size: 2rem;
  }
  .no-stress-footer {
    font-size: 1.6rem;
  }
  .goal-title {
    font-size: 1.6rem;
  }
  .model-bottom-text {
    font-size: 1.4rem;
  }
}
/*# sourceMappingURL=llp-page.component.css.map */
